import { createContext } from 'react';

import type { AdminContent, ContentKey } from './admin.types';

export type LoadStatus = 'loading' | 'ready' | 'error';

export type PublishResult =
  { ok: true; sha: string; url?: string } | { ok: false; conflict: boolean; error: string };

export interface AdminValue {
  /** Situação da leitura do conteúdo atual no GitHub. */
  status: LoadStatus;
  /** Tenta ler de novo o conteúdo atual (após erro ou conflito). */
  reload: () => void;
  content: AdminContent;
  /** Partes alteradas em relação ao que está no ar. */
  dirtyKeys: ContentKey[];
  isDirty: boolean;
  /** Partes de um rascunho antigo descartadas porque o site mudou depois dele. */
  droppedDraftKeys: ContentKey[];
  update: <K extends ContentKey>(key: K, value: AdminContent[K]) => void;
  /** Descarta o rascunho e volta ao conteúdo publicado. */
  discard: () => void;
  /** Envia as partes alteradas, só se ninguém tiver publicado no meio. */
  publish: () => Promise<PublishResult>;
  /** Nomes de todas as fotos que existem no repositório agora. */
  knownImages: ReadonlySet<string>;
  /** Fotos enviadas nesta sessão e ainda não publicadas (nome → prévia). */
  pendingImages: Readonly<Record<string, string>>;
  /** Reduz a foto, guarda até a publicação e devolve o nome do arquivo. */
  addImage: (file: File, baseName: string) => Promise<string>;
}

export const AdminContext = createContext<AdminValue | null>(null);
